import React, { useState, useEffect } from "react";

const ReceiveStatComponent = ({ width = 3 }) => {
  const [statuses, setStatuses] = useState([{ port: "9000", status: 0 }]);

  useEffect(() => {
    setTimeout(() => {
      fetch("http://127.0.0.1:8080/receiveStat")
        .then((r) => r.json())
        .then((r) => setStatuses(r));
    }, 500);
  }, [statuses]);

  const rows = [[]];
  for (let i = 0; i < statuses.length; i++) {
    if (rows[rows.length - 1].length === width) {
      rows.push([]);
    }
    rows[rows.length - 1].push(statuses[i]);
  }
  return (
    <div>
      {rows.map((r, i) => (
        <div key={i}>
          {r[0].port}
          {r.map((s) => (
            <span
              key={s.port}
              style={{
                width: "15px",
                height: "15px",
                display: "inline-block",
                margin: "0 1px",
                border: "1px solid black",
                borderRadius: "99px",
                backgroundColor:
                  s.status === 1
                    ? "green"
                    : s.status === 0
                    ? "lightgrey"
                    : "red",
              }}
              onClick={() => {
                fetch(`http://127.0.0.1:8080/terminateSingle?port=${s.port}`)
              }}
            ></span>
          ))}
          {r[r.length - 1].port}
        </div>
      ))}
    </div>
  );
};

export default ReceiveStatComponent;
